// text contents for Contact.tsx
export const contact = {
	title: `Contact Us`,
	subtitle: `Enter a subject, message, and email address below.`,
};
